import { i18n } from 'app/i18n';

export class CurrencyUtils {
    public static formatCurrency(value: number): string {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    public static formatPriceWithMonthlySuffix(value: number): string {
        return `${CurrencyUtils.formatCurrency(value)} ${i18n.currency.monthlyPriceSuffix}`;
    }

    public static formatPriceWithSuffix(value: number): string {
        return `${CurrencyUtils.formatCurrency(value)} ${i18n.currency.suffix}`;
    }

    public static toFormattedShortPrice(value: number): string {
        return `${CurrencyUtils.formatCurrency(value)}${i18n.currency.commaPriceSuffix}`;
    }
}
